// extracted by mini-css-extract-plugin
export default {"textContainer":"irxdt","shippingUnderDiscountFlag":"nxHlu","text":"r0mYG"};